/**
 * Servicios de google usados:
 * Maps JavaScript API
 * Places API
 */
export default {
  name: 'BuscadorDirecciones',
  props: {
    gapi: {
      type: Object,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    borderless: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: this.value ? this.value : '',
      positionInformation: this.setDefaultPositionInformation(),
      searchResults: [],
      sessionToken: null,
      placesApi: null, // Para almacenar las clases de la API de Places
    };
  },
  created() {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.loseFocus();
      }
    });
  },
  methods: {
    loadToken(){
      try {
        if (!this.sessionToken) {
          this.sessionToken = new this.gapi.maps.places.AutocompleteSessionToken();
        }
      } catch (error) {
        console.error('Error loading Google Places API:', error);
      }
    },
    loseFocus() {
      if (this.positionInformation.coordinates.lat === 0 && this.searchResults.length) {
        this.setPosition(this.searchResults[0]);
      }
      this.clearPredictions();
    },
    setDefaultPositionInformation() {
      return {
        coordinates: {
          lat: 0,
          lng: 0,
        },
        streetName: '',
        number: '',
        country: '',
        iso: '',
        city: '',
        state: '',
        extraInfo: '',
      };
    },
    async searchSuggestions(e) {

      this.positionInformation = this.setDefaultPositionInformation();
      this.loadToken();
      if (this.content != undefined && this.content.trim() !== '') {
        try {
          const request = {
            input: this.content,
            sessionToken: this.sessionToken,
            language: 'es-CL',
            includedRegionCodes: ['CL', 'MX'],
          };
          const { suggestions } = await this.gapi.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
          this.displaySuggestions(suggestions);
        } catch (error) {
          console.error('Error fetching autocomplete suggestions:', error);
          this.searchResults = [];
        }
      } else {
        this.searchResults = [];
        this.$emit('input', this.content);
      }
      this.$emit('keyup', e);
      this.$emit('receive', this.positionInformation);
    },
    clearPredictions() {
      this.searchResults = [];
    },
    setPosition(position) {
      const geocoder = new this.gapi.maps.Geocoder();
      geocoder.geocode({ placeId: position.place_id }, (results, status) => {
        console.log(status);
        if (results) {
          console.log("Componente ",results);
          const result = results[0];
          const lat = result.geometry.location.lat();
          const lng = result.geometry.location.lng();
          this.positionInformation.coordinates.lat = lat;
          this.positionInformation.coordinates.lng = lng;
          let mainExtraInfo, mainRoute, mainNumber, mainCountry, mainCity, mainState, mainIso;
          result.address_components.forEach((component) => {
            if (!component.types.length) {
              return;
            }
            const type = component.types[0];
            switch (type) {
              case 'subpremise':
                mainExtraInfo = component.long_name;
                break;
              case 'street_number':
                mainNumber = component.long_name;
                break;
              case 'route':
                mainRoute = component.long_name;
                break;
              case 'country':
                mainCountry = component.long_name;
                mainIso = component.short_name;
                break;
              case 'locality':
              case 'postal_town':
                mainCity = component.long_name;
                break;
              case 'administrative_area_level_1':
                mainState = component.long_name;
                break;
            }
          });
          this.positionInformation.addressComplement = mainExtraInfo;
          this.positionInformation.streetName =
            mainRoute !== undefined ? mainRoute : position.description.split(',')[0];
          this.positionInformation.number = mainNumber;
          this.positionInformation.country = mainCountry;
          this.positionInformation.iso = mainIso;
          this.positionInformation.city = mainCity;
          this.positionInformation.state = mainState;
          this.content = `${mainRoute || ''}${mainNumber && mainNumber.trim().length ? ' ' + mainNumber : ''}${
            mainCity && mainCity.trim().length ? ', ' + mainCity : ''
          }${mainState && mainState.trim().length ? ', ' + mainState : ''}${
            mainCountry && mainCountry.trim().length ? ', ' + mainCountry : ''
          }${mainIso && mainIso.trim().length ? ', ' + mainIso : ''}`;
          this.searchResults = [];
          this.$emit('input', this.content);
          this.$emit('receive', {
            city: mainCity,
            streetName: mainRoute !== undefined ? mainRoute : position.description.split(',')[0],
            number: mainNumber,
            country: mainCountry,
            iso: mainIso,
            state: mainState,
            coordinates: { lat, lng },
            addressComplement: mainExtraInfo,
            neighborhood: undefined
          });
        }
      });
    },
    displaySuggestions(suggestions) {
      if (!suggestions || !suggestions.length) {
        this.searchResults = [];
        return;
      }
      // Adaptamos la respuesta al formato que espera la UI
      this.searchResults = suggestions.map((s) => ({
        description: s.placePrediction.text.text,
        place_id: s.placePrediction.placeId,
        placePrediction: s.placePrediction,
      }));
    },
  },
  watch: {
    value: function (newValue) {
      this.content = newValue;
    },
  },
};
